import { err, ok } from '@nanovnaweb/shared';
import { ProbeError } from './errors.js';
export class DriverRegistry {
    probes = [];
    register(probe) {
        this.probes.push(probe);
    }
    listKinds() {
        return this.probes.map((p) => p.kind);
    }
    async detect(transport, opts = {}) {
        let lastError = null;
        for (const probe of this.probes) {
            const result = await probe.probe(transport, opts);
            if (result.kind === 'ok') {
                return ok(probe.create(transport, result.value));
            }
            lastError = result.error;
        }
        return err(lastError ?? new ProbeError('no-match', 'no probes registered'));
    }
}
//# sourceMappingURL=registry.js.map